module.exports = __webpack_public_path__ + "static/img/kongtiao-zhileng.1692b0a6.gif";